function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_3341",
  "data-name": "Group 3341",
  transform: "translate(-198 -154)"
}, React.createElement("circle", {
  id: "Ellipse_2575",
  "data-name": "Ellipse 2575",
  cx: 13,
  cy: 13,
  r: 13,
  transform: "translate(198 154)",
  fill: "#3db6fb"
}), React.createElement("path", {
  id: "path",
  d: "M8.993,2.5c2.974,0,5.625,2.457,5.5,5.172-.129,2.974-4.009,9.051-5.5,9.051S3.627,10.711,3.5,7.672C3.368,4.957,6.019,2.5,8.993,2.5Zm0,12.866.582-.582a21.461,21.461,0,0,0,1.552-2.069A11.833,11.833,0,0,0,13.2,7.672a4.14,4.14,0,0,0-4.2-3.879,4.14,4.14,0,0,0-4.2,3.879A11.528,11.528,0,0,0,6.86,12.715a14.345,14.345,0,0,0,1.552,2.069,2.469,2.469,0,0,0,.582.582Zm0-5.108A2.263,2.263,0,1,1,11.256,8a2.291,2.291,0,0,1-2.263,2.263Zm0-1.293A.97.97,0,1,0,8.023,8a.994.994,0,0,0,.97.97Z",
  transform: "translate(202.508 157.5)",
  fill: "#fefefe"
}));

var SvgLocationMarker = function SvgLocationMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLocationMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locationMarker.2e851994.svg";
export { ForwardRef as ReactComponent };